export const quotePluralMapping = {
  '=0': '0 quotes',
  '=1': '1 quote',
  other: '# quotes',
};
